// extracted by mini-css-extract-plugin
export default {"latestUpdateContainer":"LatestUpdateCell_latestUpdateContainer__4lJZl","baselineRow":"LatestUpdateCell_baselineRow__GG+SK"};